<div *ngIf="validMapInput">
    <mat-card class="m-3 mat-elevation-z4">
        <mat-card-header>
            <fa-icon mat-card-avatar [icon]="iconRoute" size="2x"></fa-icon>
            <mat-card-title>GPS Location Map</mat-card-title>
            <mat-card-subtitle>{{ coordinateList.length }} Location Pin(s)</mat-card-subtitle>
        </mat-card-header>
        <div mat-card-image>
            <div id="leafletMap"></div>
        </div>
    </mat-card>
</div>
<div *ngIf="!validMapInput">
    <mat-card class="m-3 mat-elevation-z4">
        <mat-card-header>
            <fa-icon mat-card-avatar [icon]="iconRoute" size="2x"></fa-icon>
            <mat-card-title>No Valid Coordinates Specified</mat-card-title>
        </mat-card-header>
    </mat-card>
</div>
